/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {AngularModule as Éµa} from './lib/angular.module';
export {MaterialModule as Éµb} from './lib/material.module';